import React, { Component } from 'react';
import { Panel } from 'react-bootstrap';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { categoryActions as actions } from '../../actions';
import { categoryConstants as constants } from '../../constants';
import RiskTypeDropdown from './RiskTypeDropdown';
import EditableMarkdown from './EditableMarkdown';
import DangerButton from '../Misc/DangerButton';
import '../../content/css/CategoryTheme.css';
import RedflagComponent from './Redflag/RedflagComponent';
import { LoadingIcon } from '../LoadingIcon';
import LoadingListener from '../../helpers/loadingListener';
import ToggleSwitch from '../ToggleSwitch';

class CategoryThemeView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            packageId: "",
            packageName: "",
            categoryCode: "",
            categoryTheme: {}
        };

        this.loadingListener = new LoadingListener([constants.GET_THEME_PACKAGES_REQUEST]);
    }

    componentDidMount() {
        const { id, code } = this.props.match.params;
        this.setState({ packageId: id, categoryCode: code });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        //If the package id changed, get the new category theme or request new theme packages.
        if (prevState.packageId !== this.state.packageId) {
            let themePackage = this.getThemePackage(this.state.packageId);
            if (themePackage === null && this.props.categories.length === 0) this.props.requestAll();
            else if (themePackage === null) this.props.requestThemePackages();
            else this.refreshCategoryTheme();
        }

        //If theme packages changed, get the selected category theme.
        if (prevProps.themePackages !== this.props.themePackages) {
            this.refreshCategoryTheme();
        }
    }

    refreshCategoryTheme = () => {
        if (this.state.categoryCode === "") return;
        let themePackage = this.getThemePackage(this.state.packageId);
        if (themePackage === null) return;

        let categoryTheme = this.getCategoryTheme(this.state.categoryCode);
        this.setState({ packageName: themePackage.name, categoryTheme });
    }

    getCategoryTheme = (code) => {
        if (!code) return;
        let themePackage = this.getThemePackage(this.state.packageId);
        if (themePackage === null) return;

        let categoryTheme = themePackage.categories.find(x => x.code === code);
        if (categoryTheme)
            categoryTheme.isAvailable = true;
        else {
            categoryTheme = this.props.categories.find(x => x.code === code);
            categoryTheme.isAvailable = false;
        }

        return categoryTheme;
    }

    handleEditIsAvailable = (value) => {
        let categoryTheme = Object.assign({}, this.state.categoryTheme);

        if (value)
            this.props.addOrUpdateCategoryTheme(this.state.packageId, categoryTheme);
        else
            this.props.removeCategoryTheme(this.state.packageId, categoryTheme);
    }

    handleEditIsActive = (value) => {
        let categoryTheme = Object.assign({}, this.state.categoryTheme);
        categoryTheme.isActive = value;
        this.props.addOrUpdateCategoryTheme(this.state.packageId, categoryTheme);
    }

    handleEditHighlightWhenFound = (value) => {
        let categoryTheme = Object.assign({}, this.state.categoryTheme);
        categoryTheme.highlightWhenFound = value;
        this.props.addOrUpdateCategoryTheme(this.state.packageId, categoryTheme);
    }

    handleEditWarnWhenMissing = (value) => {
        let categoryTheme = Object.assign({}, this.state.categoryTheme);
        categoryTheme.warnWhenMissing = value;
        this.props.addOrUpdateCategoryTheme(this.state.packageId, categoryTheme);
    }

    handleEditRisk = (value) => {
        let categoryTheme = Object.assign({}, this.state.categoryTheme);
        categoryTheme.riskType = value;
        this.props.addOrUpdateCategoryTheme(this.state.packageId, categoryTheme);
    }

    handleEditRedflag = (data, oldData) => {
        let categoryTheme = Object.assign({}, this.state.categoryTheme);
        categoryTheme.customProperties = JSON.stringify(data);
        this.props.addOrUpdateCategoryTheme(this.state.packageId, categoryTheme);
    }

    handleEditFeedbackGuidance = (text, oldText) => {
        let categoryTheme = Object.assign({}, this.state.categoryTheme);
        categoryTheme.feedbackGuidance = text;
        this.props.addOrUpdateCategoryTheme(this.state.packageId, categoryTheme);
    }

    handleEditFeedbackExamples = (text, oldText) => {
        let categoryTheme = Object.assign({}, this.state.categoryTheme);
        categoryTheme.feedbackExamples = text;
        this.props.addOrUpdateCategoryTheme(this.state.packageId, categoryTheme);
    }

    handleEditFeedbackExplanation = (text, oldText) => {
        let categoryTheme = Object.assign({}, this.state.categoryTheme);
        categoryTheme.feedbackExplanation = text;
        this.props.addOrUpdateCategoryTheme(this.state.packageId, categoryTheme);
    }

    handleEditFeedbackApproval = (text, oldText) => {
        let categoryTheme = Object.assign({}, this.state.categoryTheme);
        categoryTheme.feedbackApproval = text;
        this.props.addOrUpdateCategoryTheme(this.state.packageId, categoryTheme);
    }

    handleEditFeedbackMissingGuidance = (text, oldText) => {
        let categoryTheme = Object.assign({}, this.state.categoryTheme);
        categoryTheme.feedbackMissingGuidance = text;
        this.props.addOrUpdateCategoryTheme(this.state.packageId, categoryTheme);
    }

    handleEditFeedbackMissingExamples = (text, oldText) => {
        let categoryTheme = Object.assign({}, this.state.categoryTheme);
        categoryTheme.feedbackMissingExamples = text;
        this.props.addOrUpdateCategoryTheme(this.state.packageId, categoryTheme);
    }

    handleReset = () => {
        let categoryTheme = Object.assign({}, this.state.categoryTheme);
        this.props.removeCategoryTheme(this.state.packageId, categoryTheme);
    }

    getThemePackage = (id) => {
        var themePackages = this.props.themePackages.filter(x => x.id === id);
        return themePackages.length > 0 ? themePackages[0] : null;
    }

    render() {
        let isLoading = this.loadingListener.isLoading(this.props.isLoading);
        let code = this.state.categoryTheme ? this.state.categoryTheme.code : "null";

        return (
            <div className="category-theme-view" key={code}>
                {isLoading && <LoadingIcon isFixed={true} />}

                {!isLoading &&
                    <React.Fragment>
                        <div className="title">
                            <h2>{this.state.categoryTheme.name}</h2>
                            <span>{`code: ${this.state.categoryTheme.code}`}</span>
                        </div>
                        <p className="package-name">Theme: <Link to={`/dashboard/themes/${this.state.packageId}`}>{this.state.packageName}</Link></p>
                        <Panel>
                            <div className="panel-title-column">
                                <span className="panel-title">Importance</span>
                                <span>Change how important this concept is for the user, affecting its color and highlighting.</span>
                            </div>
                            <RiskTypeDropdown risk={this.state.categoryTheme.riskType} onChange={this.handleEditRisk} />
                            <hr />
                            <div className="panel-title-column">
                                <span className="panel-title">Availability</span>
                                <span>Toggle to make this concept visible to and editable by the user.</span>
                            </div>
                            <ToggleSwitch initialValue={this.state.categoryTheme.isAvailable} onChange={this.handleEditIsAvailable} />
                            <hr />
                            <div className="panel-title-column">
                                <span className="panel-title">Enable or disable</span>
                                <span>Toggle to enable or disable this concept.</span>
                            </div>
                            <ToggleSwitch initialValue={this.state.categoryTheme.isActive} onChange={this.handleEditIsActive} />
                            {/*<CategoryOptionEditControl isActive={this.state.categoryTheme.isActive} onChange={this.handleEditIsActive} />*/}
                            <hr />
                            <div className="panel-title-column">
                                <span className="panel-title">Highlight</span>
                                <span>Should this concept be highlighted in contracts?</span>
                            </div>
                            <ToggleSwitch initialValue={this.state.categoryTheme.highlightWhenFound} onChange={this.handleEditHighlightWhenFound} />
                            {/*<CategoryOptionEditControl isActive={this.state.categoryTheme.highlightWhenFound} onChange={this.handleEditHighlightWhenFound} />*/}
                            <hr />
                            <div className="panel-title-column">
                                <span className="panel-title">Warn when missing</span>
                                <span>Should we warn when this concept is missing in a contract?</span>
                            </div>
                            <ToggleSwitch initialValue={this.state.categoryTheme.warnWhenMissing} onChange={this.handleEditWarnWhenMissing} />
                            {/*<CategoryOptionEditControl isActive={this.state.categoryTheme.warnWhenMissing} onChange={this.handleEditWarnWhenMissing} />*/}
                            <hr />
                            <div className="panel-title-column">
                                <span className="panel-title">Reset</span>
                                <span>The concept will be reset and any custom feedback text or other data will be removed.</span>
                            </div>
                            <DangerButton warningText="Are you sure you want to reset the concept?" onClick={this.handleReset}>Reset</DangerButton>
                        </Panel>
                        <RedflagComponent
                            category={this.state.categoryTheme}
                            packageId={this.state.packageId}
                            getCategory={this.getCategoryTheme}
                            addOrUpdateCategoryTheme={(categoryTheme) => this.props.addOrUpdateCategoryTheme(this.state.packageId, categoryTheme)}
                            onSave={this.handleEditRedflag}
                        />
                        <Panel>
                            <span className="panel-title">What to do</span>
                            <hr />
                            <EditableMarkdown
                                title={this.state.categoryTheme.name}
                                markdown={this.state.categoryTheme.feedbackGuidance}
                                activeTab="guidance"
                                onSave={this.handleEditFeedbackGuidance}
                            />
                        </Panel>
                        <Panel>
                            <span className="panel-title">Example clause</span>
                            <hr />
                            <EditableMarkdown
                                title={this.state.categoryTheme.name}
                                markdown={this.state.categoryTheme.feedbackExamples}
                                activeTab="examples"
                                onSave={this.handleEditFeedbackExamples}
                            />
                        </Panel>
                        <Panel>
                            <span className="panel-title">Background</span>
                            <hr />
                            <EditableMarkdown
                                title={this.state.categoryTheme.name}
                                markdown={this.state.categoryTheme.feedbackExplanation}
                                activeTab="explanation"
                                onSave={this.handleEditFeedbackExplanation}
                            />
                        </Panel>
                        <Panel>
                            <span className="panel-title">Get approval</span>
                            <hr />
                            <EditableMarkdown
                                title={this.state.categoryTheme.name}
                                markdown={this.state.categoryTheme.feedbackApproval}
                                activeTab="approval"
                                onSave={this.handleEditFeedbackApproval}
                            />
                        </Panel>
                        {this.state.categoryTheme.warnWhenMissing &&
                            <React.Fragment>
                                <Panel>
                                    <span className="panel-title">Guidance when Missing</span>
                                    <hr />
                                    <EditableMarkdown
                                        title={this.state.categoryTheme.name}
                                        markdown={this.state.categoryTheme.feedbackMissingGuidance}
                                        style="missing concept"
                                        onSave={this.handleEditFeedbackMissingGuidance}
                                    />
                                </Panel>
                            </React.Fragment>
                        }
                    </React.Fragment>
                }
            </div>
        );
    }
}

export default connect(
    state => state.category,
    dispatch => bindActionCreators(actions, dispatch)
)(CategoryThemeView);


// WEBPACK FOOTER //
// ./src/components/CategoryView/CategoryThemeView.js